export default {
  SnippetStarted: "Snippet Başlatıldı",
  SnippetStopped: "Snippet Durduruldu",
  StartSnippet: "Snippet Başlat",
  StartFrom30sAgo: "30 saniye öncesinden başlat",
  StartFrom10sAgo: "10 saniye öncesinden başlat",
  StartNow: "Şimdi başlat",
  StopSnippet: "Snippet Durdur",
  SnippetDescription: "Snippet Açıklaması",
  SnippetSuccess: "Snippet başarıyla kaydedildi",
  SnippetFailed: "Snippet işlemi başarısız oldu",
  SnippetActive: "Snippet Aktif",
  SnippetCannedResponses: "Snippet Açıklamaları",
  ScreenshotsAndSnippets: "Ekran Görüntüleri & Snippet'ler",
  "Events.SnippetStarted": "Snippet Başlatıldı",
  "Events.SnippetStopped": "Snippet Durduruldu",
};
